import { defineStore } from "pinia";
import { erebus } from "boot/axios";
import { useAuthStore } from "stores/auth";
import { Feature } from "src/models/feature";

export const useFeatureStore = defineStore({
  persist: true,
  id: "Feature",
  state: () => ({
    clientFeatures: [] as Feature[]
  }),
  getters: {
    getClientFeatures: (state) => (clientID: number): Feature[] | undefined => {
      return state.clientFeatures.filter((f: Feature) => f.clientID === clientID);
    },
    // We default to true if the feature is not found
    hasFeature: (state) => (clientID: number, featureName: string): boolean => {
      const clientFeatures = state.clientFeatures.filter((f: Feature) => f.clientID === clientID);
      if (!clientFeatures) {
        return true;
      }
      const feature = clientFeatures.find((f: Feature) => f.name === featureName);
      if (!feature) {
        return true;
      }
      return feature.enabled;
    },
    strictHasFeature: (state) => (clientID: number, featureName: string): boolean => {
      const clientFeatures = state.clientFeatures.filter((f: Feature) => f.clientID === clientID);
      if (!clientFeatures) {
        return false;
      }
      const feature = clientFeatures.find((f: Feature) => f.name === featureName);
      if (!feature) {
        return false;
      }
      return feature.enabled;
    }
  },
  actions: {
    async fetchClientFeatures(clientID: number): Promise<void> {
      if (!clientID) {
        return;
      }
      const res = await erebus.get(`/features/client/${clientID}`);
      this.clearClientFeatures(clientID);
      this.clientFeatures.push(...res.data);
    },
    clearClientFeatures(clientID: number): void {
      this.clientFeatures = this.clientFeatures.filter((f: Feature) => f.clientID !== clientID);
    },
    async dataRefresh(): Promise<void> {
      this.clientFeatures = [];
      const authStore = useAuthStore();
      await this.fetchClientFeatures(Number(authStore.clientId));
    }
  }
});
